<template>
  <transition name="appfade">
    <div v-show="appIsLoaded" class="generic-page--template page-template">
      <div class="db relative center z-0 w-100 h-auto">
        <div class="container-fluid">
          <section class="db relative center mw7 tc pt5 pb5">
            <h3 class="tc mv4 ttu is-bebas is-white page-title">{{ page.title }}</h3>
            <div class="cms-content tl">
              <div class="row middle-sm">
                <div class="col-xs-12 col-sm-5">
                  <img class="db relative center mv3 img-responsive lazy-load" :src="page.content_blocks.image" :data-src="page.content_blocks.image"/>
                </div>
                <div class="col-xs-12 col-sm-6 ph0 ph3-ns" >
                  <div class="relative mt3 cms-content" v-html="page.content_blocks.block_1_text">
                    <!-- {{ content }} -->
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 ph0 mv3" v-html="page.content_blocks.block_2_text">
                  <!-- {{ content }} -->
                </div>
              </div>
            </div>
            <div class="mv3 ph0 cms-content tl is-interstate-regular is-white" v-html="page.content">
              <!-- {{ content }} -->
            </div>s
          </section>
        </div>
      </div>
    </div>
  </transition> 
</template>

<script>
import AppHeader from './app-header.vue';
import AppFooter from './app-footer.vue';
import { bus } from '../assets/js/src/main';
import Marked from 'marked';
export default {
  //template: '#generic-page',
  components: {
    'app-header': AppHeader,
    'app-footer': AppFooter
  },
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        // If undefined or blank then we don't need the hyphen
        return titleChunk ? `${titleChunk} | ` + this.$site_name : this.$site_name;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      appIsLoaded: true,
      newItem: 'Data binding',
      newDynamic: [],
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName('about.md');
      return pageData[0];
    }
  },
  methods : {
    //
  }
}
</script>